export function readTrimmedString(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined

  const trimmedValue = value.trim()
  return trimmedValue || undefined
}

export function readTranslatedString(source: Record<string, unknown>, key: string): string | undefined {
  return readTrimmedString(source[`${key}-i18n`])
}

export function readTrimmedStringArray(value: unknown): Array<string> | undefined {
  if (!Array.isArray(value)) return undefined

  return value.map(readTrimmedString).filter((item): item is string => !!item)
}
